import React from 'react';
import { Helmet } from 'react-helmet'; // You need to import Helmet
import ActualitesAAMTDM from '../components/ActualitesAAMTDM';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';
// Make sure 'logo' is defined and imported if it's a local asset
// For example, if 'logo.png' is in 'src/assets':
// import logo from '../assets/logo.png'; 

function App() {
  // If 'logo' is a global URL string, you can define it here or as a constant
  const websiteLogoUrl = "https://www.museedestroupesdemarine.fr/logo.png"; // Replace with your actual logo URL

  return (
    <div className="App">
      <Helmet>
        {/* Basic Meta Tags */}
        <title>Musée des Troupes de Marine - Actualités de l'AAMTDM</title>
        <meta name="description" content="Découvrez les dernières actualités de l'Association des Amis du Musée des Troupes de Marine" />
        <meta name="keywords" content="Musée des Troupes de Marine, histoire militaire, histoire, histoire des troupes de marine, conférences, actualités, patrimoine" />

        {/* Favicons for all browsers and devices */}
        {/* Ensure these files (favicon.ico, apple-touch-icon.png, manifest.json) are in your public folder */}
        <link rel="icon" href="/favicon.ico" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        <link rel="manifest" href="/manifest.json" />

        {/* Open Graph (for Facebook, LinkedIn, etc.) */}
        <meta property="og:title" content="Musée des Troupes de Marine - Actualités de l'AAMTDM" />
        <meta property="og:description" content="Découvrez les dernières actualités de l'Association des Amis du Musée des Troupes de Marine" />
        {/* Important: 'og:image' must be the ABSOLUTE and PUBLIC URL of your image */}
        <meta property="og:image" content={websiteLogoUrl} /> {/* Use the defined URL */}
        <meta property="og:url" content="https://www.museedestroupesdemarine.fr/pages/ActualitesAAMTDM" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="fr_FR" />

        {/* Twitter Card (for Twitter) */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Musée des Troupes de Marine - Actualités de l'AAMTDM" />
        <meta name="twitter:description" content="Découvrez les dernières actualités de l'Association des Amis du Musée des Troupes de Marine." />
        <meta name="twitter:image" content={websiteLogoUrl} /> {/* Use the same URL as og:image */}
        {/* <meta name="twitter:site" content="@NomDeTonCompteTwitter" /> If you have a Twitter account for the museum */}
        {/* <meta name="twitter:creator" content="@NomDeTonCompteTwitter" /> For the specific content author */}

        {/* Canonical tags to avoid duplicate content */}
        <link rel="canonical" href="https://www.museedestroupesdemarine.fr/pages/ActualitesAAMTDM" />

        {/* Mobile optimization (often already in index.html, but useful here if you need to override) */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
      </Helmet>
      <ActualitesAAMTDM />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;